
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiContentCollapseGoogle as ObiContentCollapseGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-content-collapse-google.js';
 
 
 

 
 export const ObiContentCollapseGoogle = createComponent({
   react: React,
   tagName: 'obi-content-collapse-google',
   elementClass: ObiContentCollapseGoogleElement,
   events: {
     
   }
  });
 
 